<template>
  <div>
    <div class="search-con search-con-top">
      <Button @click="editInfo(false)" class="search-btn" type="primary"><Icon type="search" />新增</Button>
    </div>
    <!-- <template>
      <Tree :data="multipleSelection"></Tree>
    </template> -->
    <Table
      border
      :columns="columns1"
      :data="multipleSelection"  style="overflow-y: hidden;text-align:left"
    >
      <!-- <template
        slot-scope="{ row }"
        slot="type"
      >
        <Tag
          color="blue"
          v-if="row.type===0"
        >目录</Tag>
        <Tag
          color="green"
          v-if="row.type===1"
        >菜单</Tag>
        <Tag
          color="gold"
          v-if="row.type===2"
        >按钮</Tag>
      </template> -->
    </Table>
    <div class="page-con">
      <Page
        :total="showData.total"
        :page-size="10"
        @on-change="changepage"
        :current="showData.pageNum"
        show-elevator
        class="pull-right"
      />
    </div>
  </div>
</template>

<script>
import expandRow from '../../components/expand.vue';
export default {
  data() {
    return {
      showDeletewin: false,  //显示删除提示
      showData: {
        list: [],          //列表容器
        pageNum: 1
      },
      multipleSelection: [],
      columns1: [           //表头
        { title: 'ID', key: 'menuId' },
        {  //添加的expand
          type: 'expand',
          width: 40,
          render: (h, params) => {
            return h(expandRow, {
              style: {
                padding: 0,
              },
              props: {
                row: params.row,
                
              }
            })
          }
        },
        {title: '名称', key: 'name', ellipsis: true,
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }
              }, params.row.name)
            ]);
          }
        },
        { title: '上级菜单', key: 'parentName' },
        { title: '图标', key: 'icon' },
        { title: '类型', key: 'type', slot: 'type' },
        { title: '排序号', key: 'orderNum' },
        { title: '菜单URL', key: 'url' },
        { title: '授权标识', key: 'perms' },
        {          title: '操作', key: 'action', width: 150, align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: { type: 'primary', size: 'small' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.editInfo(params.row.menuId)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: { type: 'error', size: 'small' },
                on: {
                  click: () => {
                    this.deleteInfo(params.row.menuId)
                  }
                }
              }, '删除')
            ])
          }
        }
      ]
    }
  },
  components: {
    expandRow
  },
  activated() {
    this.getList ()
  },
  mounted() {
    this.getList()
  },
  methods: {
    changepage(current) {
      this.showData.pageNum = current
      this.getList() 
    },
    getList() {
      
      this.$Loading.start()
      this.$axios.get('/sys/menu/list')
        .then(function (response) {
          if (response.data.success) {
            this.multipleSelection = this.$treeDataTranslate(response.data.data, 'menuId')
            this.showData.list = response.data.data
            this.$Loading.finish()
          } else {
            this.$Message.error(response.data.errMsg);
            this.$Loading.error()
          }
        }.bind(this))
    },
    editInfo(id) {
     
      
      this.$router.push({ path: '/menu/edit', query: { id: id } })
    },
    deleteInfo (id) {
    
      this.$Modal.confirm({
        title: '删除',
        content: '<p>您确定要删除吗</p>',
        onOk: () => {
            this.$Loading.start()
           
            this.$axios.get('sys/menu/delete/'+id)
            .then(function (response) {
                if (response.data.success) {
                  this.getList()
                  this.$Message.success(response.data.errMsg)
                  this.$Loading.finish()
                } else {
                  this.$Message.error(response.data.errMsg)
                  this.$Loading.error()
                }
            }.bind(this))
        },
        onCancel: () => {
          this.$Message.warning('已取消删除')
        }
      });
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/views/menu/list.vue